import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";

import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
} from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import moment from "moment";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CatalogoClasifIslr from "../../catalogos/catalogoClasifIslr";
import { Dimmer } from "../spinner";
import {
  Input,
  Radio,
  Textarea,
  Select,
  Checkbox,
} from "../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import { width } from "@mui/system";
import ModalDocumentosDigitales from "./modalDocumentosDigitales";

export const ActualizarProveedor = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [files, setFiles] = useState({
    registroMercantil: { file: "", preview: "", error: false },
    balance: { file: "", preview: "", error: false },
    servicioNacional: { file: "", preview: "", error: false },
    cedula: { file: "", preview: "", error: false },
    sunacoop: { file: "", preview: "", error: false },
    planillaIsrl: { file: "", preview: "", error: false },
    rif: { file: "", preview: "", error: false },
    solvenciaIvss: { file: "", preview: "", error: false },
    solvenciaInces: { file: "", preview: "", error: false },
    solvenciaLaboral: { file: "", preview: "", error: false },
    solvenciaMunicipal: { file: "", preview: "", error: false },
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2] = useState();
  const [msg2] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [bloqueado, setBloqueado] = useState(false);
  const txtDescrp = useRef();
  const txtRazonS = useRef();
  const txtDenominacion = useRef();
  const txtCiudad = useRef();
  const txtRif = useRef();
  const txtTelef = useRef();
  const txtEmailP = useRef();
  const txtEmailS = useRef();
  const txtCed = useRef();
  const txtActv = useRef();
  const txtFechaIn = useRef();
  const txtRtislr = useRef();
  const txtCapp = useRef();
  const txtCaps = useRef();
  const txtStatus = useRef();
  const txtFondter = useRef();
  const txtExentoIva = useRef();
  const txtFechaReg = useRef();
  const txtOficReg = useRef();
  const txtProtocolo = useRef();
  const txtTomo = useRef();
  const txtFolio = useRef();
  const txtNumReg = useRef();
  const txtFechaActualiza = useRef();
  const txtRcomercio = useRef();
  const txtBgva = useRef();
  const txtTipocontri = useRef();
  const txtSrvnc = useRef();
  const txtCdRp = useRef();
  const txtCsun = useRef();
  const txtPislr = useRef();
  const txtRifAct = useRef();
  const txtSivss = useRef();
  const txtSinces = useRef();
  const txtSlab = useRef();
  const txtSmunip = useRef();
  const txtLcAct = useRef();
  const txtCodae = useRef();
  const txtBienesS = useRef();
  const txtContratista = useRef();
  const txtFondos = useRef();
  const txtOrganismo = useRef();
  const txtBeneficiario = useRef();
  const txtNombreRespon = useRef();
  const txtApellidoRespon = useRef();
  const txtDireccionRespon = useRef();
  const txtEmailRespon = useRef();
  const txtTlfRespon = useRef();
  const [operacionPer, setOperacionPer] = useState(0);
  const txtCelRespon = useRef();
  const txtFechaNac = useRef();
  const cmbSexo = useRef();
  const cmbNacionalidad = useRef();
  const txtIdc = useRef();
  const txtEstado = useRef();
  const [tecla, setTecla] = useState();
  const txtMunicipio = useRef();
  const txtDescriClasifIsrl = useRef();
  const txtCodClasifIsrl = useRef();
  const [visibleF, setVisibleF] = useState("hidden");
  const [habilitadoNR, setHabilitadoNR] = useState(false);
  const [valuespersona, setValuesPersona] = useState({
    cedula: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    apellidos: "",
    direccion: "",
    fnacimiento: "",
    nacionalidad: "",
    nombres: "",
    sexo: "",
  });
  const [valuest, setValuest] = useState({
    idestado: "",
    idmunicipio: "",
    idciudad: "",
  });
  const [values, setValues] = useState({
    idproveedor: "",
    razonsocial: "",
    denominacioncomercial: "",
    direccion: "",
    ciudad: "",
    rif: "",
    nit: "",
    telefono: "",
    responsable: "",
    actprincipal: "",
    fechaincripcion: "",
    fecharegistro: "",
    retencionislr: 0.0,
    cappagado: 0.0,
    capsubsc: 0.0,
    tipocontribnac: "",
    rbalance: "",
    rccirl: "",
    rcnit: "",
    rcrif: "",
    rdislr: "",
    restresult: "",
    rregcomercio: "",
    rregivss: "",
    rregince: "",
    rsolvince: "",
    rsolvlaboral: "",
    rsolvindcomercio: "",
    exentoiva: "",
    fondotercero: "",
    oficinaregistro: "",
    protocolo: "",
    tomo: "",
    folio: "",
    numero: "",
    tipo: "",
    codigo: "",
    numiae: "",
    codiae: "",
    correoepri: "",
    correoesec: "",
    fecha_rnc_snc: "",
    status: "",
    clasifisrl: "",
    codclasifisrl: "",
  });

  const [ciudad, setCiudad] = useState();
  const [municipio, setMunicipio] = useState();

  const onChange = (event) => {
    if (event.target.name === "idestado") {
      setValuest({
        ...valuest,
        [event.target.name]: event.target.value,
        idmunicipio: "",
        idciudad: "",
      });
      setMunicipio();
      setCiudad();

      if (event.target.value !== "") {
        seleccionarMunicipio(event.target.value);
      }
    } else if (event.target.name === "idmunicipio") {
      setValuest({
        ...valuest,
        [event.target.name]: event.target.value,
        idciudad: "",
      });
      setCiudad();

      if (event.target.value !== "") {
        seleccionarCiudad(event.target.value);
      }
    } else if (event.target.name === "idciudad") {
      setValuest({ ...valuest, [event.target.name]: event.target.value });
    }
    if (
      event.target.name === "razonsocial" ||
      event.target.name === "direccion" ||
      event.target.name === "correoe" ||
      event.target.name === "apellidos" ||
      event.target.name === "nombres" ||
      event.target.name === "actprincipal" ||
      event.target.name === "oficinaregistro" ||
      event.target.name === "direccion" ||
      event.target.name === "rif" ||
      event.target.name === "correoepri" ||
      event.target.name === "correoesec"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeDenominacion = (event) => {
    //alert(txtDenominacion.current.value);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth,
        );
      }
      if (event.which === 13) {
        if (event.target.id === "inputRetencion") {
          txtRtislr.focus();
        }
      }
      if (event.which === 13) {
        if (event.target.id === "inputCappago") {
          txtCapp.focus();
        }
      }
      if (event.which === 13) {
        if (event.target.id === "inputCapsub") {
          txtCaps.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputCel") {
        valido = validaNumeroTelefono(event.target.value);
        if (valido) {
          txtFechaNac.current.focus();
        } else {
          if (event.target.value !== "") {
            setTitulo("Información");
            setMsg("Formato de número telefonico invalido.");
            setMostrar(true);
            event.target.value = "";
          } else {
            txtFechaNac.current.focus();
          }
        }
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    var valido;
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const seleccionarCiudad = (idciudad) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idciudad}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setCiudad(response.data);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);

        setActivate(false);
      });
  };

  const seleccionarMunicipio = (idestado) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idestado}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setMunicipio(response.data);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setActivate(false);
      });
  };

  const Actualizar = (operacion) => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/createProveedor/${operacion}`;
    setActivate(true);
    const formData = new FormData();
    const rec = [
      txtRcomercio.current.checked,
      txtBgva.current.checked,
      txtSrvnc.current.checked,
      txtCdRp.current.checked,
      txtCsun.current.checked,
      txtPislr.current.checked,
      txtRifAct.current.checked,
      txtSivss.current.checked,
      txtSinces.current.checked,
      txtSlab.current.checked,
      txtSmunip.current.checked,
    ];
    const reg = [
      txtFechaReg.current.value.trim() || "null",
      txtProtocolo.current.value.trim() || "null",
      txtTomo.current.value.trim() || "null",
      txtFolio.current.value.trim() || "null",
      txtNumReg.current.value.trim() || "null",
      txtContratista.current.checked
        ? "1"
        : txtBienesS.current.checked
          ? "0"
          : txtFondos.current.checked
            ? "2"
            : txtBeneficiario.current.checked
              ? "3"
              : "4",
      txtNumReg.current.value.trim() || "null",
      txtLcAct.current.value.trim() || "null",
      txtCodae.current.value.trim() || "null",
    ];
    formData.append("nid", parseInt(txtIdc.current.value) || 0);
    formData.append("rsoc", txtRazonS.current.value.trim());
    formData.append("dencom", txtDenominacion.current.value.trim());
    formData.append("direc", txtDescrp.current.value.trim());
    formData.append("ciud", txtCiudad.current.value);
    formData.append("ri", txtRif.current.value.trim());
    formData.append("telf", txtTelef.current.value.trim());
    formData.append("resp", txtCed.current.value);
    formData.append("actpri", txtActv.current.value.trim());
    formData.append(
      "fechinsc",
      txtFechaIn.current.value.trim() === ""
        ? fechaSistema
        : txtFechaIn.current.value.trim(),
    );
    const formatMonto = (val) =>
      val.trim().replace(/\./g, "").replace(",", ".");
    formData.append(
      "reten",
      txtRtislr.current.value === ""
        ? "0.00"
        : formatMonto(txtRtislr.current.value),
    );
    formData.append(
      "cappa",
      txtCapp.current.value === ""
        ? "0.00"
        : formatMonto(txtCapp.current.value),
    );
    formData.append(
      "capsu",
      txtCaps.current.value === ""
        ? "0.00"
        : formatMonto(txtCaps.current.value),
    );
    formData.append(
      "tipcontna",
      txtTipocontri.current.value === ""
        ? props.tcontribuyente[1].idtipocontribuyente
        : txtTipocontri.current.value.trim(),
    );
    formData.append(
      "stat",
      txtStatus.current.value === "" ? 1 : parseInt(txtStatus.current.value),
    );
    formData.append("recaudos", rec.toString());
    formData.append("operacionper", operacionPer);
    formData.append("cor", txtEmailRespon.current.value.trim());
    formData.append("ctlf1", txtTlfRespon.current.value.trim());
    formData.append("ctlf2", txtCelRespon.current.value.trim());
    formData.append("ape", txtApellidoRespon.current.value.trim());
    formData.append("dir", txtDireccionRespon.current.value.trim());
    formData.append("fnac", txtFechaNac.current.value.trim());
    formData.append("nac", cmbNacionalidad.current.value.trim());
    formData.append("nombres", txtNombreRespon.current.value.trim());
    formData.append("sex", cmbSexo.current.value.trim());
    formData.append("exento", txtExentoIva.current.checked);
    formData.append("fondoter", txtFondter.current.checked);
    formData.append("ofireg", txtOficReg.current.value.trim());
    formData.append("datreg", reg.toString());
    formData.append("correopri", txtEmailP.current.value.trim());
    formData.append("correosec", txtEmailS.current.value.trim());
    formData.append(
      "clasisrl",
      txtCodClasifIsrl.current.value === ""
        ? "000"
        : txtCodClasifIsrl.current.value,
    );
    Object.keys(files).forEach((key) => {
      if (files[key].file && files[key].file instanceof File) {
        formData.append(key, files[key].file);
      }
    });
    axios
      .post(endpoint, formData, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          const mensajes = {
            1: "Registro Creado Correctamente.",
            2: "Registro Modificado Correctamente.",
            3: "Registro Eliminado Correctamente.",
          };
          setTitulo("Notificación");
          setMsg(mensajes[props.operacion] || "Operación realizada con éxito.");
          setMostrar(true);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(
          error.response && error.response.data
            ? error.response.data.message
            : "Error en el servidor",
        );
        setMostrar(true);
        setActivate(false);
      });
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            txtNombreRespon.current.value = "";
            txtApellidoRespon.current.value = "";
            txtDireccionRespon.current.value = "";
            txtEmailRespon.current.value = "";
            txtTlfRespon.current.value = "";
            txtCelRespon.current.value = "";
            txtFechaNac.current.value = "";
            cmbNacionalidad.current.value = "V";
            cmbSexo.current.value = "M";
          }

          setHabilitadoNR(true);

          if (response.data !== "") {
            setHabilitadoNR(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres.trim();
            txtApellidoRespon.current.value = response.data.apellidos.trim();
            txtDireccionRespon.current.value = response.data.direccion.trim();
            txtEmailRespon.current.value = response.data.correoe.trim();
            txtTlfRespon.current.value = response.data.tlf1.trim();
            txtCelRespon.current.value = response.data.tlf2.trim();
            txtFechaNac.current.value = moment
              .utc(response.data.fnacimiento)
              .format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              txtIdc.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNR(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar3(true);
    }
  };

  const catalogoClasi = (e) => {
    e.preventDefault();
    if (operacion < 3) {
      setMostrar4(true);
    }
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion === 1 || operacion === 2) {
      if (txtRazonS.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Debe Describir la Razón Social");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtRazonS.current.focus();
        setMostrar(true);
      } else if (txtDenominacion.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Por Favor Seleccione la Denominacion Comercial");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtDenominacion.current.focus();
        setMostrar(true);
      } else if (txtDescrp.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("La Dirección no debe ir Vacia");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtDescrp.current.focus();
        setMostrar(true);
      } else if (txtEstado.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Por Favor Seleccione el Estado");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtEstado.current.focus();
        setMostrar(true);
      } else if (txtMunicipio.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Por Favor Seleccione el Municipio");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtMunicipio.current.focus();
        setMostrar(true);
      } else if (txtCiudad.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Por Favor Seleccione la Ciudad");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtCiudad.current.focus();
        setMostrar(true);
      } else if (txtRif.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("El Campo RIF no Debe ir Vacio");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtRif.current.focus();
        setMostrar(true);
      } else if (txtCed.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Por Favor Seleccione el Encargado");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtCed.current.focus();
        setMostrar(true);
      } else if (txtNombreRespon.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Los Nombres no deben estar Vacios");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtNombreRespon.current.focus();
        setMostrar(true);
      } else if (txtApellidoRespon.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("Los Apellidos no deben estar Vacios");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtApellidoRespon.focus();
        setMostrar(true);
      } else if (txtDireccionRespon.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("La Dirección no debe estar Vacia");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtDireccionRespon.current.focus();
        setMostrar(true);
      } else if (txtFechaNac.current.value.trim() === "") {
        setTitulo("Error");
        setMsg("La Fecha de Nacimiento no Debe Estar Vacia");
        sigue = false;
        setTabIndex(0); // Tab 1
        txtFechaNac.focus();
        setMostrar(true);
      } else if (
        txtActv.current.value.trim() === "" &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("Debe Definir la Actividad Principal");
        sigue = false;
        setTabIndex(1); // Tab 2
        txtActv.current.focus();
        setMostrar(true);
      } else if (
        txtFechaIn.current.value.trim() === "" &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("Por Favor Seleccione la Fecha de Inscripción");
        sigue = false;
        setTabIndex(1); // Tab 2
        txtFechaIn.current.focus();
        setMostrar(true);
      } else if (
        txtRtislr.current.value.trim() === "" &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("El Campo Retención I.S.L.R NO debe ir Vacio");
        sigue = false;
        setTabIndex(1); // Tab 2
        txtRtislr.current.focus();
        setMostrar(true);
      } else if (
        txtCapp.current.value.trim() === "" &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("El Campo Capital Pagado NO debe ir Vacio");
        sigue = false;
        setTabIndex(1); // Tab 2
        txtCapp.current.focus();
        setMostrar(true);
      } else if (
        txtCaps.current.value.trim() === "" &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("El Campo Capital Subscrito NO debe ir Vacio");
        sigue = false;
        setTabIndex(1); // Tab 2
        txtCaps.current.focus();
        setMostrar(true);
      } else if (
        txtTipocontri.current.value.trim() === "" &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("Por Favor Seleccione el Tipo de Contribuyente");
        sigue = false;
        setTabIndex(1); // Tab 2 (Asumiendo que está en el tab 2 según tu código original)
        txtTipocontri.current.focus();
        setMostrar(true);
      } else if (
        txtStatus.current.value.trim() === "" &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("Por Favor Seleccione el Estatus");
        sigue = false;
        setTabIndex(1); // Tab 2
        txtStatus.current.focus();
        setMostrar(true);
      } else if (
        txtOficReg.current.value.trim().length > 100 &&
        txtDenominacion.current[
          txtDenominacion.current.selectedIndex
        ].text.trim() !== "PERSONA NATURAL"
      ) {
        setTitulo("Error");
        setMsg("Debe Definir la Oficina de Registro");
        sigue = false;
        setTabIndex(1); // Tab 2
        txtOficReg.current.focus();
        setMostrar(true);
      } else if (sigue === true) {
        Actualizar(props.operacion);
      }
    } else if (sigue === true) {
      Actualizar(props.operacion);
    }
  };

  const blanquear = () => {
    setVisible(false);
    setMostrar1(false);
    setMostrar(false);
    setActivate(false);
    setOperacionPer(0);
    setValuesPersona({
      cedula: "",
      correoe: "",
      tlf1: "",
      tlf2: "",
      apellidos: "",
      direccion: "",
      fnacimiento: "",
      nacionalidad: "",
      nombres: "",
      sexo: "",
    });
    setValuest({
      idestado: "",
      idmunicipio: "",
      idciudad: "",
    });
    setValues({
      idproveedor: "",
      razonsocial: "",
      denominacioncomercial: "",
      direccion: "",
      ciudad: "",
      rif: "",
      nit: "",
      telefono: "",
      responsable: "",
      actprincipal: "",
      fechaincripcion: "",
      fecharegistro: "",
      retencionislr: 0.0,
      cappagado: 0.0,
      capsubsc: 0.0,
      tipocontribnac: "",
      rbalance: "",
      rccirl: "",
      rcnit: "",
      rcrif: "",
      rdislr: "",
      restresult: "",
      rregcomercio: "",
      rregivss: "",
      rregince: "",
      rsolvince: "",
      rsolvlaboral: "",
      rsolvindcomercio: "",
      exentoiva: "",
      fondotercero: "",
      oficinaregistro: "",
      protocolo: "",
      tomo: "",
      folio: "",
      numero: "",
      tipo: "",
      codigo: "",
      numiae: "",
      codiae: "",
      correoepri: "",
      correoesec: "",
      fecha_rnc_snc: "",
      status: "",
    });
    setTabIndex(0);
    setOperacion(0);
    setBloqueado(false);
    setVisibleF("hidden");
    setMsg("");
    setFiles({
      registroMercantil: { file: "", preview: "", error: false },
      balance: { file: "", preview: "", error: false },
      servicioNacional: { file: "", preview: "", error: false },
      cedula: { file: "", preview: "", error: false },
      sunacoop: { file: "", preview: "", error: false },
      planillaIsrl: { file: "", preview: "", error: false },
      rif: { file: "", preview: "", error: false },
      solvenciaIvss: { file: "", preview: "", error: false },
      solvenciaInces: { file: "", preview: "", error: false },
      solvenciaLaboral: { file: "", preview: "", error: false },
      solvenciaMunicipal: { file: "", preview: "", error: false },
    });
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg == "Registro Creado Correctamente." ||
      msg == "Registro Modificado Correctamente." ||
      msg == "Registro Eliminado Correctamente."
    ) {
      blanquear();
      props.onHideCancela();
      props.onHideRenderizar();
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setHabilitadoNR(false);
    blanquear();
    props.onHideCancela();
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer,
  ) => {
    setMostrar3(false);
    txtCed.current.value = cedPer;
    txtNombreRespon.current.value = nomPer;
    txtApellidoRespon.current.value = apePer;
    txtDireccionRespon.current.value = direPer;
    txtEmailRespon.current.value = correoPer;
    txtTlfRespon.current.value = tlf1Per;
    txtCelRespon.current.value = tlf2Per;
    txtFechaNac.current.value = moment.utc(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    txtIdc.current.focus();
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaClasificIslr = (codigo, actividad, porcentaje) => {
    setMostrar4(false);
    txtCodClasifIsrl.current.value = codigo;
    let porce = formatMoneda(
      porcentaje.replace(",", "").replace(".", ","),
      ",",
      ".",
      2,
    );
    txtDescriClasifIsrl.current.value = actividad + " - " + porce;
  };
  const handleCloseClasificIslr = () => {
    setMostrar4(false);
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setVisible(false);
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        setTabIndex(0);
        if (props.operacion !== 1) {
          setValues(props.proveedor);
          setValuesPersona(props.persona);
          setValuest({
            idestado: props.estadoT.idestado,
            idmunicipio: props.municipioT.idmunicipio,
            idciudad: props.ciudadT.idciudad,
          });
          seleccionarMunicipio(props.estadoT.idestado);
          seleccionarCiudad(props.municipioT.idmunicipio);
          txtCodClasifIsrl.current.value = props.clasif.codigo;
          if (props.clasif.codigo !== "000") {
            //txtCodClasifIsrl.current.value = props.clasif.codigo;
            let porce = formatMoneda(
              props.clasif.porcentaje.replace(",", "").replace(".", ","),
              ",",
              ".",
              2,
            );
            txtDescriClasifIsrl.current.value =
              props.clasif.actividad + " - " + porce;
          } else {
            txtDescriClasifIsrl.current.value = "";
          }
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title>
          {operacion === 1
            ? "Agregar Proveedor."
            : operacion === 2
              ? "Modificar Proveedor."
              : operacion === 3
                ? "Eliminar Proveedor."
                : "Consultar Proveedor."}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <CatalogoClasifIslr
        titulo={titulo}
        mensaje={msg}
        show={mostrar4}
        onHideCancelaClasif={handleCloseClasificIslr}
        onHideAceptaClasif={handleAceptaClasificIslr}
      />
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <ul className="nav " id="ex-with-icons" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className={`nav-link rounded ${tabIndex === 0 ? "active bg-blue-100 text-light" : "bg-blue-200 text-light"}`}
              id="datosTributarios"
              type="button"
              role="tab"
              aria-controls="tributarios"
              aria-selected={tabIndex === 0}
              onClick={(e) => {
                e.preventDefault();
                setTabIndex(0);
              }}
            >
              Datos del Proveedor
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className={`nav-link rounded ${tabIndex === 1 ? "active bg-blue-100 text-light" : "bg-blue-200 text-light"}`}
              id="datosTributarios2"
              type="button"
              role="tab"
              aria-controls="tributarios2"
              aria-selected={tabIndex === 1}
              onClick={(e) => {
                e.preventDefault();
                if (
                  txtDenominacion.current[
                    txtDenominacion.current.selectedIndex
                  ].text.trim() === "PERSONA NATURAL"
                ) {
                  setTabIndex(0);
                } else {
                  setTabIndex(1);
                }
              }}
            >
              Otros Datos
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className={`nav-link rounded ${tabIndex === 2 ? "active bg-blue-100 text-light" : "bg-blue-200 text-light"}`}
              id="datosTributarios2"
              type="button"
              role="tab"
              aria-controls="tributarios2"
              aria-selected={tabIndex === 2}
              onClick={(e) => {
                e.preventDefault();
                setTabIndex(2);
              }}
            >
              Documentos Digitales
            </a>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className={`tab-pane fade ${tabIndex === 0 ? "show active" : ""}`}
            id="tributarios"
            role="tabpanel"
            aria-labelledby="datosTributarios"
          >
            <div className="col-12 m-0 mt-2 p-0 d-flex flex-wrap">
              <div className="col-4 m-0 p-0">
                <Input
                  label="Código:"
                  disabled={true}
                  ref={txtIdc}
                  name="idproveedor"
                  value={values.idproveedor}
                  id="inputCodigo"
                />
              </div>
              <div className="col-4 m-0 ml-auto p-0">
                <Input
                  label="N° de Inscripción:"
                  disabled={true}
                  id="inputCodigo"
                />
              </div>
            </div>
            <fieldset className="col-12 m-0 mb-2 p-2 d-flex gap-2 flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">Tipo</legend>
              <div>
                <Radio
                  label="Bienes y Servicios"
                  id="customRadioInline1"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value="0"
                  name="tipo"
                  defaultChecked={
                    props.proveedor && props.proveedor.tipo === "0"
                      ? true
                      : false
                  }
                  ref={txtBienesS}
                />
              </div>
              <div>
                <Radio
                  label="Contratista de Obras"
                  id="customRadioInline2"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value="1"
                  name="tipo"
                  defaultChecked={
                    props.proveedor && props.proveedor.tipo === "1"
                      ? true
                      : false
                  }
                  ref={txtContratista}
                />
              </div>
              <div>
                <Radio
                  label="Fondo Terceros"
                  id="customRadioInline3"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value="2"
                  name="tipo"
                  defaultChecked={
                    props.proveedor && props.proveedor.tipo === "2"
                      ? true
                      : false
                  }
                  ref={txtFondos}
                />
              </div>
              <div>
                <Radio
                  label="Organismos"
                  id="customRadioInline4"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value="4"
                  name="tipo"
                  defaultChecked={
                    props.proveedor && props.proveedor.tipo === "4"
                      ? true
                      : false
                  }
                  ref={txtOrganismo}
                />
              </div>
              <div>
                <Radio
                  label="Beneficiario"
                  id="customRadioInline5"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value="3"
                  name="tipo"
                  defaultChecked={
                    props.proveedor && props.proveedor.tipo === "3"
                      ? true
                      : false
                  }
                  ref={txtBeneficiario}
                />
              </div>
            </fieldset>
            <div className="col-12 m-0 mt-2 p-0 d-flex flex-wrap">
              <div className="col-6 m-0 mb-2 p-0">
                <Input
                  label="Razón Social:"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  name="razonsocial"
                  defaultValue={
                    values && values.razonsocial
                      ? values.razonsocial.trim()
                      : ""
                  }
                  onChange={onChange}
                  id="inputCodigo"
                  ref={txtRazonS}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Select
                  label="Den. Comercial:"
                  name="denominacioncomercial"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value={values ? values.denominacioncomercial : ""}
                  onChange={onChange}
                  id="inputFechaReg"
                  ref={txtDenominacion}
                >
                  <option value={""}>SELECCIONAR DEN.COMERCIAL</option>
                  {props.denominacion &&
                    props.denominacion.map((item, index) => (
                      <option key={index} value={item.iddenominacioncomercial}>
                        {" "}
                        {item.descripcion}{" "}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea
                  label="Dirección:"
                  style={{ height: 70 }}
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  name="direccion"
                  onChange={onChange}
                  defaultValue={
                    values && values.direccion ? values.direccion.trim() : ""
                  }
                  id="inputDescripcion"
                  ref={txtDescrp}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Select
                  label="Estado:"
                  name="idestado"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value={valuest && valuest.idestado}
                  onChange={onChange}
                  id="inputFechaReg"
                  ref={txtEstado}
                >
                  <option value={""}>SELECCIONAR ESTADO</option>
                  {props.estado &&
                    props.estado.map((item, index) => (
                      <option key={index} value={item.idestado}>
                        {" "}
                        {item.nombre}{" "}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="Municipio:"
                  name="idmunicipio"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value={valuest && valuest.idmunicipio}
                  onChange={onChange}
                  id="inputFechaReg"
                  ref={txtMunicipio}
                >
                  <option value={""}>SELECCIONAR MUNICIPIO</option>
                  {municipio &&
                    municipio.map((item, index) => (
                      <option key={index} value={item.idmunicipio}>
                        {" "}
                        {item.nombre}{" "}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Select
                  label="Ciudad:"
                  name="idciudad"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  value={valuest && valuest.idciudad}
                  onChange={onChange}
                  id="inputFechaReg"
                  ref={txtCiudad}
                >
                  <option value={""}>SELECCIONAR CIUDAD</option>
                  {ciudad &&
                    ciudad.map((item, index) => (
                      <option key={index} value={item.idciudad}>
                        {" "}
                        {item.nombre}{" "}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Input
                  label="Telefono(s):"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  name="telefono"
                  defaultValue={
                    values && values.telefono ? values.telefono.trim() : ""
                  }
                  onChange={handleInputNumChange}
                  id="inputCodigo"
                  ref={txtTelef}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="RIF:"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  name="rif"
                  defaultValue={values && values.rif ? values.rif.trim() : ""}
                  onChange={onChange}
                  id="inputCodigo"
                  ref={txtRif}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="E-mail Principal:"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  name="correoepri"
                  defaultValue={
                    values && values.correoepri ? values.correoepri.trim() : ""
                  }
                  onChange={onChange}
                  id="inputCodigo"
                  ref={txtEmailP}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Input
                  label="E-mail Secundario:"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  name="correoesec"
                  defaultValue={
                    values && values.correoesec ? values.correoesec.trim() : ""
                  }
                  onChange={onChange}
                  id="inputCodigo"
                  ref={txtEmailS}
                />
              </div>
            </div>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded align-items-center">
              <legend className="float-none w-auto m-0">Encargado</legend>
              <div className="col-5 m-0 mb-2 p-0 d-flex align-items-center">
                <div className="col-4 m-0 p-0">
                  <Select
                    label="Cedula:"
                    disabled={!habilitadoNR}
                    name="nacionalidad"
                    defaultValue={
                      props.persona ? props.persona.nacionalidad : ""
                    }
                    onChange={onChange}
                    ref={cmbNacionalidad}
                  >
                    <option value="V">V</option>
                    <option value="E">E</option>
                  </Select>
                </div>
                <div className="col m-0 p-0 pr-2">
                  <Input
                    className="rounded-0"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="responsable"
                    defaultValue={values.responsable}
                    id="inputCedula"
                    onKeyUp={validarPersona}
                    onBlur={validarPersona}
                    ref={txtCed}
                  />
                </div>
                <InfoButton
                  icon="fa-search m-0"
                  disabled={
                    operacion === 4 || operacion === 3 ? true : deshabilitado
                  }
                  onClick={catalogoPer}
                ></InfoButton>
              </div>
              <div className="col-4 m-0 mb-2 ml-auto p-0">
                <Input
                  label="Fecha de Nacimiento:"
                  type="date"
                  disabled={!habilitadoNR}
                  max={moment.utc(fechaSistema).format("YYYY-MM-DD")}
                  name="fnacimiento"
                  defaultValue={
                    props.persona && props.persona.fnacimiento
                      ? moment
                          .utc(props.persona.fnacimiento)
                          .format("YYYY-MM-DD")
                      : ""
                  }
                  onKeyUp={handleInputChange}
                  id="FechaNac"
                  ref={txtFechaNac}
                />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input
                  label="Nombres:"
                  disabled={!habilitadoNR}
                  name="nombres"
                  defaultValue={
                    valuespersona && valuespersona.nombres
                      ? valuespersona.nombres.trim()
                      : ""
                  }
                  onChange={onChange}
                  id="inputNombreRespon"
                  ref={txtNombreRespon}
                />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Input
                  label="Apellidos:"
                  disabled={!habilitadoNR}
                  name="apellidos"
                  defaultValue={
                    valuespersona && valuespersona.apellidos
                      ? valuespersona.apellidos.trim()
                      : ""
                  }
                  onChange={onChange}
                  id="inputApellidosRespon"
                  ref={txtApellidoRespon}
                />
              </div>
              <div className="col-12 m-0 mb-2 p-0">
                <Textarea
                  label="Dirección:"
                  style={{ height: 70 }}
                  disabled={!habilitadoNR}
                  name="direccion"
                  defaultValue={
                    valuespersona && valuespersona.direccion
                      ? valuespersona.direccion.trim()
                      : ""
                  }
                  onChange={onChange}
                  id="inputDireccionRespon"
                  ref={txtDireccionRespon}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0">
                <Input
                  label="E-mail:"
                  disabled={!habilitadoNR}
                  name="correoe"
                  defaultValue={
                    valuespersona && valuespersona.correoe
                      ? valuespersona.correoe.trim()
                      : ""
                  }
                  onChange={onChange}
                  id="inputCorreoRespon"
                  ref={txtEmailRespon}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Telefono:"
                  disabled={!habilitadoNR}
                  name="tlf1"
                  defaultValue={
                    valuespersona && valuespersona.tlf1
                      ? valuespersona.tlf1.trim()
                      : ""
                  }
                  onChange={handleInputNumChange}
                  id="inputTel"
                  ref={txtTlfRespon}
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Celular:"
                  disabled={!habilitadoNR}
                  name="tlf2"
                  defaultValue={
                    valuespersona && valuespersona.tlf2
                      ? valuespersona.tlf2.trim()
                      : ""
                  }
                  onChange={handleInputNumChange}
                  id="inputCel"
                  ref={txtCelRespon}
                />
              </div>
              <div className="col-4 m-0 p-0">
                <Select
                  label="Sexo:"
                  disabled={!habilitadoNR}
                  ref={cmbSexo}
                  name="sexo"
                  defaultValue={props.persona ? props.persona.sexo : ""}
                  onChange={onChange}
                >
                  <option value="">Seleccionar </option>
                  <option value="M">MASCULINO</option>
                  <option value="F">FEMENINO</option>
                </Select>
              </div>
            </fieldset>
          </div>
          <div
            className={`tab-pane fade ${tabIndex === 1 ? "show active" : ""}`}
            id="tributarios2"
            role="tabpanel"
            aria-labelledby="datosTributarios2"
          >
            <div className="col-12 m-0 mt-2 p-0 d-flex">
              <div className="col m-0 p-0 pr-2">
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Actividad Principal:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="actprincipal"
                    defaultValue={
                      values && values.actprincipal
                        ? values.actprincipal.trim()
                        : ""
                    }
                    onChange={onChange}
                    id="inputCodigo"
                    ref={txtActv}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Fecha de Inscripción:"
                    type="date"
                    ref={txtFechaIn}
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="fechaincripcion"
                    value={
                      values
                        ? values.fechaincripcion
                          ? moment
                              .utc(values.fechaincripcion)
                              .format("YYYY-MM-DD")
                          : ""
                        : ""
                    }
                    onChange={onChange}
                    id="inputCodigo"
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="% Retención ISLR:"
                    ref={txtRtislr}
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="retencionislr"
                    defaultValue={
                      values && values.retencionislr
                        ? formatMoneda(
                            values.retencionislr
                              .replace(",", "")
                              .replace(".", ","),
                            ",",
                            ".",
                            2,
                          )
                          ? formatMoneda(
                              values.retencionislr
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                    id="inputRetencion"
                  />
                </div>
                <div class="input-group input-group-sm mb-2 col-12 p-0 w-100">
                  <div class="input-group input-group-sm col-12 p-0 w-100 mb-2">
                    <span class="input-group-text" id="inputGroup-sizing-sm">
                      Clasf. I.S.L.R:
                    </span>
                    <button
                      type="button"
                      class="btn btn-info"
                      onClick={catalogoClasi}
                    >
                      <i class="fas fa-search"></i>
                    </button>
                    <input
                      className="form-control"
                      disabled={true}
                      id="inputCodClasifIsrl"
                      ref={txtCodClasifIsrl}
                    />
                    {/*   <Input  disabled={true} id="inputDireccion" ref={txtCodClasifIsrl} /> */}
                  </div>
                  <Textarea
                    style={{ height: 70 }}
                    disabled={true}
                    ref={txtDescriClasifIsrl}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Capital Pagado:"
                    ref={txtCapp}
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="cappagado"
                    defaultValue={
                      values && values.cappagado
                        ? formatMoneda(
                            values.cappagado.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2,
                          )
                          ? formatMoneda(
                              values.cappagado
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                    id="inputCappago"
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Capital Subscrito:"
                    ref={txtCaps}
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="capsubsc"
                    defaultValue={
                      values && values.capsubsc
                        ? formatMoneda(
                            values.capsubsc.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2,
                          )
                          ? formatMoneda(
                              values.capsubsc
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )
                          : ""
                        : ""
                    }
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                    id="inputCapsub"
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Select
                    label="Tipo de Contribuyente:"
                    name="tipocontribnac"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    value={values ? values.tipocontribnac : ""}
                    onChange={onChange}
                    id="inputFechaReg"
                    ref={txtTipocontri}
                  >
                    <option value={""}>SELECCIONAR</option>
                    {props.tcontribuyente &&
                      props.tcontribuyente.map((item, index) => (
                        <option key={index} value={item.idtipocontribuyente}>
                          {" "}
                          {item.descripcion}{" "}
                        </option>
                      ))}
                  </Select>
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Select
                    label="Estatus del Proveedor:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    id="inputStatus"
                    name="status"
                    value={values && values.status.trim()}
                    onChange={onChange}
                    ref={txtStatus}
                  >
                    <option value="">SELECCIONAR</option>
                    <option value="1">ACTIVO</option>
                    <option value="0">INACTIVO</option>
                  </Select>
                </div>

                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.fondotercero === true
                        ? true
                        : false
                    }
                    id="fondoTercero"
                    ref={txtFondter}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="fondoTercero"
                    style={{ cursor: "pointer" }}
                  >
                    Fondo de Tercero?
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.exentoiva === true
                        ? true
                        : false
                    }
                    id="exentoIva"
                    ref={txtExentoIva}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="exentoIva"
                    style={{ cursor: "pointer" }}
                  >
                    Exonerado IVA?
                  </label>
                </div>

                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Fecha de Registro:"
                    type="date"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="fecharegistro"
                    value={
                      values
                        ? values.fecharegistro
                          ? moment
                              .utc(values.fecharegistro)
                              .format("YYYY-MM-DD")
                          : ""
                        : ""
                    }
                    onChange={onChange}
                    id="inputCodigo"
                    ref={txtFechaReg}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea
                    label="Oficina de Registro:"
                    style={{ height: 40 }}
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    id="inputDescripcion"
                    name="oficinaregistro"
                    onChange={onChange}
                    defaultValue={values.oficinaregistro.trim()}
                    ref={txtOficReg}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Protocolo:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="protocolo"
                    defaultValue={
                      values && values.protocolo ? values.protocolo.trim() : ""
                    }
                    onChange={handleInputNumChange}
                    id="inputCodigo"
                    ref={txtProtocolo}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="N° de Tomo:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="tomo"
                    defaultValue={
                      values && values.tomo ? values.tomo.trim() : ""
                    }
                    onChange={handleInputNumChange}
                    id="inputCodigo"
                    ref={txtTomo}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Folio:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="folio"
                    defaultValue={
                      values && values.folio ? values.folio.trim() : ""
                    }
                    onChange={handleInputNumChange}
                    id="inputCodigo"
                    ref={txtFolio}
                  />
                </div>
                <div className="col-12 m-0 p-0">
                  <Input
                    label="N° de Registro:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="numero"
                    defaultValue={
                      values && values.numero ? values.numero.trim() : ""
                    }
                    onChange={handleInputNumChange}
                    id="inputCodigo"
                    ref={txtNumReg}
                  />
                </div>
              </div>
              <div className="col m-0 p-4 border-azul rounded">
                <h3 className="fw-bold border-bottom">Copias de Recaudos</h3>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    id="#1"
                    ref={txtRcomercio}
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rregcomercio === true
                        ? true
                        : false
                    }
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#1"
                    style={{ cursor: "pointer" }}
                  >
                    Registro Mercantil/Modificaciones
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rcnit === true
                        ? true
                        : false
                    }
                    id="#2"
                    ref={txtBgva}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#2"
                    style={{ cursor: "pointer" }}
                  >
                    Balance Gral. Visado y Auditado
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rcrif === true
                        ? true
                        : false
                    }
                    id="#3"
                    ref={txtSrvnc}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#3"
                    style={{ cursor: "pointer" }}
                  >
                    Servicio Nacional Contratista
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rccirl === true
                        ? true
                        : false
                    }
                    id="#4"
                    ref={txtCdRp}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#4"
                    style={{ cursor: "pointer" }}
                  >
                    Cédula del Representante
                  </label>
                </div>
                <div className="col-12 m-0  p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rbalance === true
                        ? true
                        : false
                    }
                    id="#5"
                    ref={txtCsun}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#5"
                    style={{ cursor: "pointer" }}
                  >
                    Constancia Sunacoop
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rdislr === true
                        ? true
                        : false
                    }
                    id="#6"
                    ref={txtPislr}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#6"
                    style={{ cursor: "pointer" }}
                  >
                    Planilla ISLR Ultimo Ejercicio
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.restresult === true
                        ? true
                        : false
                    }
                    id="#7"
                    ref={txtRifAct}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#7"
                    style={{ cursor: "pointer" }}
                  >
                    RIF Actualizado
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rregivss === true
                        ? true
                        : false
                    }
                    id="#8"
                    ref={txtSivss}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#8"
                    style={{ cursor: "pointer" }}
                  >
                    Solvencia IVSS
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rsolvince === true
                        ? true
                        : false
                    }
                    id="#9"
                    ref={txtSinces}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#9"
                    style={{ cursor: "pointer" }}
                  >
                    Solvencia INCES
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor && props.proveedor.rsolvlaboral === true
                        ? true
                        : false
                    }
                    id="#10"
                    ref={txtSlab}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#10"
                    style={{ cursor: "pointer" }}
                  >
                    Solvencia Laboral
                  </label>
                </div>
                <div className="col-12 m-0 p-0">
                  <input
                    type="checkbox"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    defaultChecked={
                      props.proveedor &&
                      props.proveedor.rsolvindcomercio === true
                        ? true
                        : false
                    }
                    id="#11"
                    ref={txtSmunip}
                  />
                  <label
                    className="ms-2 p-0"
                    htmlFor="#11"
                    style={{ cursor: "pointer" }}
                  >
                    Solvencia Municipal
                  </label>
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input
                    label="Ultima Actualización:"
                    type="date"
                    disabled={true}
                    name="fecha_rnc_snc"
                    onChange={onChange}
                    id="inputActualizacion"
                    ref={txtFechaActualiza}
                  />
                </div>
                <div className="col-12 m-0 mb-2  p-0">
                  <Input
                    label="N° Lic. Act. Económica:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="numiae"
                    defaultValue={
                      values && values.numiae ? values.numiae.trim() : ""
                    }
                    onChange={handleInputNumChange}
                    id="inputCodigo"
                    ref={txtLcAct}
                  />
                </div>
                <div className="col-12 m-0 mb-2  p-0">
                  <Input
                    label="Código de Actividad Económica:"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    name="codiae"
                    defaultValue={
                      values && values.codiae ? values.codiae.trim() : ""
                    }
                    onChange={handleInputNumChange}
                    id="inputCodigo"
                    ref={txtCodae}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`tab-pane fade ${tabIndex === 2 ? "show active" : ""}`}
            id="subirDocumentos"
            role="tabpanel"
            aria-labelledby="subirDocumentos"
          >
            <ModalDocumentosDigitales
              disabled={
                operacion === 4 || operacion === 3 ? true : deshabilitado
              }
              id={txtIdc.current ? txtIdc.current.value : ""}
              files={files}
              setFiles={setFiles}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: "" }}>
        <SuccessButton
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeSiNo
        titulo={titulo2}
        mensaje={msg2}
        show={mostrar1}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
